import { render, staticRenderFns } from "./AddIncomingTransactionFormFrame.vue?vue&type=template&id=5fba9da3&scoped=true&"
import script from "./AddIncomingTransactionFormFrame.vue?vue&type=script&lang=js&"
export * from "./AddIncomingTransactionFormFrame.vue?vue&type=script&lang=js&"
import style0 from "./AddIncomingTransactionFormFrame.vue?vue&type=style&index=0&id=5fba9da3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba9da3",
  null
  
)

export default component.exports